function UserProfile() {
  return (
    <div>
      <h2>User Profile Management</h2>
    </div>
  );
}

export default UserProfile;
